export default {
  name: 'KOptgroup',
  props: {
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  render() {
    return (
      <div class="km-optgroup">
        <div class="km-optgroup__label">{this.label}</div>
        <div class="km-optgroup__content">{this.$slots.default}</div>
      </div>
    )
  },
  methods: {},
}
